import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  styled
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { color } from 'config/color'
import { useMobileBreakpoints } from 'utils'
import { MButton } from 'components'
import { useState } from 'react'

import phoneImage from 'assets/images/column-required-phone.png'
import emailImage from 'assets/images/column-required-email.png'

interface IUploadCsvDialogBox {
  isOpen: boolean
  handleClose: () => void
  templateType: string
  onChange: any
}

export const UploadCsvDialogBox = (props: IUploadCsvDialogBox): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false)

  const isMobile = useMobileBreakpoints()

  return (
    <Dialog open={props.isOpen} onClose={props.handleClose} maxWidth="sm">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <DialogTitle>Column Required</DialogTitle>
        <IconButton onClick={props.handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ paddingTop: 0 }}>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          gap={2}
        >
          <img
            src={props.templateType === 'email' ? emailImage : phoneImage}
            alt="phone-csv-format"
          />

          <Box>
            <Typography
              fontSize={isMobile ? 14 : 16}
              color={color.grey[700]}
              display="inline"
            >
              {'The uploaded csv file must have a '}
            </Typography>

            <Typography
              fontSize={isMobile ? 14 : 16}
              color={color.grey[900]}
              fontWeight={500}
              display="inline"
            >
              {props.templateType === 'email' ? 'email column' : 'phone column'}
            </Typography>

            <Typography
              fontSize={isMobile ? 14 : 16}
              color={color.grey[700]}
              display="inline"
            >
              {props.templateType === 'email'
                ? ' header that contains the primary email of the customer'
                : ' header that contains the telephone number of the customer to be called'}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            gap={1}
          >
            <MButton
              component="label"
              variant="contained"
              type="button"
              rounded="true"
              texttransform="none"
              loading={isLoading}
              disabled={isLoading}
            >
              Upload CSV File
              <VisuallyHiddenInput
                type="file"
                accept=".csv"
                onChange={(e) => {
                  setIsLoading(true)
                  props.onChange(e.target.files ? e.target.files[0] : null)
                  setIsLoading(false)
                  props.handleClose()
                }}
              />
            </MButton>
            <MButton
              variant="outlined"
              type="button"
              rounded="true"
              texttransform="none"
              disabled={isLoading}
              onClick={props.handleClose}
            >
              Go Back to Campaigns
            </MButton>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})
